import { Component, Input } from '@angular/core';
import { ICardComponentData } from 'src/app/interfaces/components';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input() data: ICardComponentData[];
  constructor() {}
}
